import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import CategoryPage from './pages/CategoryPage';
import StaticPage from './pages/StaticPage';
import RequestPage from './pages/RequestPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import TelegramSettings from './pages/TelegramSettings';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <div className="App" dir="rtl">
        <Helmet>
          <html lang="ar" dir="rtl" />
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/category/:categoryName" element={<CategoryPage />} />
            <Route path="/page/:slug" element={<StaticPage />} />
            <Route path="/request" element={<RequestPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route 
              path="/admin/dashboard" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/telegram-settings" 
              element={
                <ProtectedRoute>
                  <TelegramSettings />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
